import styled from '@emotion/styled';
import { Stack } from '@mui/system';
import { FC } from 'react';

import Fund1 from '@/assets/png/fund-dashboard/hands.png';
import { Tooltip, Typography } from '@/design-system';

import { FundsTabTableRow } from '../data';

const CoverImg = styled('img')({
  width: 40,
  height: 40,
  borderRadius: '8px',
  objectFit: 'cover',
  objectPosition: 'center',
});

type Props = Pick<FundsTabTableRow, 'name' | 'thumbnailUrl'>;

export const FundNameCell: FC<Props> = ({ name, thumbnailUrl }) => {
  return (
    <Stack alignItems="center" gap="8px" overflow="hidden">
      <CoverImg src={thumbnailUrl || Fund1} alt={name} />

      <Tooltip title={name} disabled={name.length < 32}>
        <Typography variant="body3" fontWeight={500} noWrap as="label">
          {name}
        </Typography>
      </Tooltip>
    </Stack>
  );
};
